Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    progressTrackerTrackWidthSmall: 4,
    progressTrackerTrackWidthLarge: 8,
    progressTrackerTrackBackgroundColorTheme: tokens.themeBackgroundAccentDefault,
    progressTrackerTrackBackgroundColorNeutral: tokens.themeBorderTertiaryDefault,
    progressTrackerMilestoneDiameterSmall: 12,
    progressTrackerMilestoneDiameterLarge: 24,
    progressTrackerMilestoneForegroundColorPastDefault: tokens.themeForegroundPrimaryDefault,
    progressTrackerMilestoneForegroundColorPresentDefault: tokens.themeForegroundInvertedDefault,
    progressTrackerMilestoneForegroundColorPresentError: tokens.themeForegroundPrimaryDefault,
    progressTrackerMilestoneForegroundColorPresentWarning: "#232F3E",
    progressTrackerMilestoneForegroundColorFutureDefault: tokens.themeForegroundPrimaryDefault,
    progressTrackerMilestoneBackgroundColorThemePastDefault: tokens.themeBackgroundAccentDefault,
    progressTrackerMilestoneBackgroundColorThemePastLargeDefault: tokens.themeBackgroundAccentDefault,
    progressTrackerMilestoneBackgroundColorThemePastSmallDefault: tokens.themeBackgroundAccentDefault,
    progressTrackerMilestoneBackgroundColorThemePastSmallWarning: tokens.themeBackgroundSecondaryWarning,
    progressTrackerMilestoneBackgroundColorThemePastSmallError: tokens.themeBackgroundSecondaryError,
    progressTrackerMilestoneBackgroundColorThemePresentDefault: tokens.themeForegroundAccentDefault,
    progressTrackerMilestoneBackgroundColorThemePresentWarning: tokens.themeBackgroundSecondaryWarning,
    progressTrackerMilestoneBackgroundColorThemePresentError: tokens.themeBackgroundSecondaryError,
    progressTrackerMilestoneBackgroundColorThemeFutureDefault: "rgba(0, 0, 0, 0)",
    progressTrackerMilestoneBackgroundColorNeutralPastDefault: tokens.themeBackgroundTertiaryDefault,
    progressTrackerMilestoneBackgroundColorNeutralPastLargeDefault: tokens.themeBackgroundTertiaryDefault,
    progressTrackerMilestoneBackgroundColorNeutralPastSmallDefault: tokens.themeBackgroundTertiaryDefault,
    progressTrackerMilestoneBackgroundColorNeutralPastSmallWarning: tokens.themeBackgroundSecondaryWarning,
    progressTrackerMilestoneBackgroundColorNeutralPastSmallError: tokens.themeBackgroundSecondaryError,
    progressTrackerMilestoneBackgroundColorNeutralPresentDefault: tokens.themeForegroundSecondaryDefault,
    progressTrackerMilestoneBackgroundColorNeutralPresentWarning: tokens.themeBackgroundSecondaryWarning,
    progressTrackerMilestoneBackgroundColorNeutralPresentError: tokens.themeBackgroundSecondaryError,
    progressTrackerMilestoneBackgroundColorNeutralFutureDefault: "rgba(0, 0, 0, 0)",
    progressTrackerMilestoneBorderWidth: 2,
    progressTrackerMilestoneBorderRadius: 999,
    progressTrackerMilestoneBorderColorThemePastDefault: tokens.themeBorderAccentDefault,
    progressTrackerMilestoneBorderColorThemePastLargeDefault: tokens.themeBorderAccentDefault,
    progressTrackerMilestoneBorderColorThemePastSmallDefault: tokens.themeBorderAccentDefault,
    progressTrackerMilestoneBorderColorThemePastSmallWarning: tokens.themeBorderPrimaryWarning,
    progressTrackerMilestoneBorderColorThemePastSmallError: tokens.themeBorderPrimaryError,
    progressTrackerMilestoneBorderColorThemePresentDefault: tokens.themeForegroundAccentDefault,
    progressTrackerMilestoneBorderColorThemePresentWarning: tokens.themeBorderPrimaryWarning,
    progressTrackerMilestoneBorderColorThemePresentError: tokens.themeBorderPrimaryError,
    progressTrackerMilestoneBorderColorThemeFutureDefault: tokens.themeForegroundAccentDefault,
    progressTrackerMilestoneBorderColorThemeFutureWarning: tokens.themeBorderPrimaryWarning,
    progressTrackerMilestoneBorderColorThemeFutureError: tokens.themeBorderPrimaryError,
    progressTrackerMilestoneBorderColorNeutralPastDefault: tokens.themeBorderSecondaryDefault,
    progressTrackerMilestoneBorderColorNeutralPastLargeDefault: tokens.themeBorderSecondaryDefault,
    progressTrackerMilestoneBorderColorNeutralPastSmallDefault: tokens.themeBorderSecondaryDefault,
    progressTrackerMilestoneBorderColorNeutralPastSmallWarning: tokens.themeBorderPrimaryWarning,
    progressTrackerMilestoneBorderColorNeutralPastSmallError: tokens.themeBorderPrimaryError,
    progressTrackerMilestoneBorderColorNeutralPresentDefault: tokens.themeForegroundSecondaryDefault,
    progressTrackerMilestoneBorderColorNeutralPresentWarning: tokens.themeBorderPrimaryWarning,
    progressTrackerMilestoneBorderColorNeutralPresentError: tokens.themeBorderPrimaryError,
    progressTrackerMilestoneBorderColorNeutralFutureDefault: tokens.themeForegroundSecondaryDefault,
    progressTrackerMilestoneBorderColorNeutralFutureWarning: tokens.themeBorderPrimaryWarning,
    progressTrackerMilestoneBorderColorNeutralFutureError: tokens.themeBorderPrimaryError
  }
};